export const breakpoints = {
  sm: '375px',
  md: '768px',
  lg: '1024px',
}